export const oilStickerSizes = Object.freeze([
  { name: '1” x 2”', value: 'stamp-one', label: '1x2' },
  { name: '1.25” x 2.25”', value: 'stamp-two', label: '1.25x2.25' },
  { name: '1.5” x 2.5”', value: 'stamp-three', label: '1.5x2.5' },
  { name: '1.75” x 2.5” ', value: 'stamp-four', label: '1.75x2.5' },
  { name: '2” x 1” ', value: 'stamp-five', label: '2x1' },
  { name: '2” x 2” ', value: 'stamp-six', label: '2x2' },
  { name: '2” x 2.75” ', value: 'stamp-seven', label: '2x2.75' },
  { name: '2” x 3” ', value: 'stamp-eight', label: '2x3' },
  { name: '2” x 4” ', value: 'stamp-nine', label: '2x4' },
  { name: '2.25” x 1.5” ', value: 'stamp-ten', label: '2.25x1.5' },
  { name: '4” x 4” ', value: 'stamp-eleven', label: '4x4' },
]);
